module.exports = __webpack_public_path__ + "static/orange-logo-adb5952b0b8dcf7b4a048e9405f1fa3f.svg";